import React from 'react';
import { withRouter } from 'react-router';
import { HUB_TILES } from '../performanceAiData.js';

export class PerformanceAIHub extends React.Component {
    handleTileClick = (link) => {
        this.props.history.push(link);
    };

    render() {
        return (
            <>
                <p className="pa-hub-subtitle">5 modules · JKLC / Relaxo / Healthium</p>
                <div className="pa-hub-grid">
                    {HUB_TILES.map((tile) => (
                        <button
                            key={tile.key}
                            type="button"
                            className="pa-hub-tile"
                            onClick={() => this.handleTileClick(tile.link)}
                        >
                            <span className="pa-hub-tile-icon">{tile.icon}</span>
                            <span className="pa-hub-tile-label">{tile.label}</span>
                            {tile.sub && <span className="pa-hub-tile-sub">{tile.sub}</span>}
                        </button>
                    ))}
                </div>
            </>
        );
    }
}

export default withRouter(PerformanceAIHub);
